module.exports = __webpack_public_path__ + "static/media/tc.bca9f99c.svg";